<template>
    <div class="business-container-phone w-100">
      <div class="d-flex justify-content-center align-items-center">
        <div class="d-flex flex-column justify-content-between align-items-start w-100">
          <span class="merriweather-bold-p16 w-100 text-center pb-3">Hortense for Business</span>
  
          <div class="business-section px-4 py-3">
            <div
              v-for="item in items"
              :key="item[0]"
              @click="goToLink(item[1])"
            >
              <div class="raleway-medi-p15 text-center item-link">
                {{ item[0] }}
              </div>
            </div>
          </div>
  
          <div class="align-items-center all-items d-flex justify-content-center pt-4 w-100">
            <a href="/seminaire-eco-responsable" class="hortense-btn-primary raleway-bold-p" target="_blank">Nous contacter</a>
          </div>
  
          <div class="w-100 d-flex justify-content-center align-items-center py-5">
            <img
              src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/activit%C3%A9s-qui-donnent-du-sens.webp"
              alt="Business"
              class="img-business"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NavbarBusinessPhone',
    data() {
      return {
        items: [
          ["Séminaires d'entreprise", "/seminaire-eco-responsable"],
          ["Coffrets cadeaux entreprise", "/coffrets-cadeaux-entreprise"],
          ["Coffrets cadeaux CSE", "/coffrets-cadeaux-cse"],
          ["Hortense for Travel Advisor", "/dmc-luxe-france"]
        ]
      }
    },
    methods: {
      goToLink(link) {
        window.open(link, '_blank');
      }
    }
  }
  </script>
  
  <style scoped>
  .business-container-phone {
    gap: 40px;
    text-transform: capitalize !important;
  
    .img-business {
      width: 350px;
      height: 195px;
      object-fit: cover;
    }
  
    .business-section {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 30px;
  
      .item-link {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  
    .raleway-bold-16 {
      font-family: 'Raleway';
      font-weight: 700;
      font-size: 16px;
    }
  }
  </style>
  